import { FilterOneItem } from "@/shared/components/GenericSearchBar/model/FilterOneItem";
import {
  EXTENSIONS_FILE_ALLOWED,
  FILE_TYPE,
  TYPES_FILE_ALLOWED
} from "@/shared/constants/GeneralConstants";

export const MEDICAL_ORDER_CONSTANTS = {
  TITLE: "Creación de orden",
  LOAD_ORDERS_TITLE: "Cargue masivo de órdenes (Temporales y Nuevas)",
  TITLE_VALIDATION_ERRORS: "Errores en la validación del cargue",
  TITLE_ERRORS: "Errores en la generación de órdenes",
  ROWS_OK: "Procesados: ",
  ROWS_ERROR: "Con errores: ",
  SELECT_SERVICE_TEMPLATE: "Seleccione un servicio",
  SERVICE_CONFIG_TEXT: "Configurar servicio",
  ORDER_TYPES: ["Interna", "Externa"],
  END_ORDER: "Finalizar orden",
  LOAD_FILE_MESSAGE: {
    NO_DATA: "No se encontró información en el archivo",
    ERROR_LOAD_FILE: "Ocurrió un error al cargar el archivo",
    NO_DATA_PROCESSING: "No existe información para procesar"
  },
  TYPE: {
    SERVICE: "service",
    SESSIONS: "sessions"
  },
  LABELS: {
    USER: "Usuario por ",
    ASSIGN_SERVICE: "Asignación de servicio",
    FORMAT_VALID: "El formato debe ser CSV, XLS o XLSX",
    SELECT_FILE: "Seleccione un archivo*",
    MAX_SIZE: "El archivo debe pesar menos de 200KB",
    LOADING: "Estamos procesando el archivo no recargue ni cierre esta ventana"
  },
  HINT: {
    USER: "Seleccione un usuario"
  },
  MESSAGES: {
    WARNING: "El usuario ya presenta una orden con este servicio",
    INFO: "Cuando la sesión se complete se generará la factura"
  },
  STATES: {
    COMPLETE: "Completo"
  },
  BUTTON: {
    LOAD_BUTTON: "Cargar ordenes"
  },
  LOAD: {
    TITLE: "Cargue Masivo",
    MESSAGE: "¿Está seguro que desea realizar el cargue?"
  },
  FILE_LINK: `https://firebasestorage.googleapis.com/v0/b/neumodesarrollo.appspot.com/o/application%2FEsquema_Cargue_Ordenes_Masivas.xlsx?alt=media&token=${process.env.VUE_APP_ORDER_TEMPLATE_TOKEN}`,
  CLEAR: {
    TITLE: "Limpiar Información",
    MESSAGE: "¿Está seguro que desea limpiar la información?"
  },
  CLEAR_INFORMATION: "Limpiar Información",
  DOWNLOAD_TEMPLATE: "Descargar Plantilla",
  IDS: {
    MEDICAL_ORDER_PRICE_LEVEL_LIST_SEL: "medicalOrderPriceLevelListSel"
  },
  TITLE_ORDER_DETAIL: "Detalle de Orden"
};

export const FILE_SIZE = 200000;

export const MEDICAL_ORDER_VALIDATORS = {
  MAX_FILE_SIZE: (v: File) =>
    !v || v.size < FILE_SIZE || MEDICAL_ORDER_CONSTANTS.LABELS.MAX_SIZE,
  FILE_FORMAT: (v: File) =>
    !v ||
    TYPES_FILE_ALLOWED.includes(v.type) ||
    EXTENSIONS_FILE_ALLOWED.includes(
      v.name
        .split(".")
        .pop()!
        .toLowerCase()
    ) ||
    MEDICAL_ORDER_CONSTANTS.LABELS.FORMAT_VALID
};

export const MEDICAL_ORDER_FILE_FORMAT = `${FILE_TYPE.csv}, ${FILE_TYPE.xls}, ${FILE_TYPE.xlsx}`;

export const CLOSE_MASIVE_ORDER_MODAL = "closeMasiveOrderModal";

export const CLOSE_ORDER_MODAL = "closeOrderModal";

export const NO_PATIENT = "noPatient";

export const FILTER_QUERY_DEFAULT_MEDICAL_ORDER = {
  userState: "Activo",
  externalUser: true
};
export const FILTER_SEARCH_USER_MEDICAL_ORDER: FilterOneItem = {
  labelTitle: " del usuario",
  labelNotFound: "No se encontró usuario para esa busqueda",
  labelAddTitle: "No se encontró usuario con esta busqueda",
  labelAddSubTitle: " Crear nuevo usuario",
  addIcon: "mdi-plus-circle-outline",
  defaultUpdate: "userDocument",
  filters: [
    { name: "Nombre", id: "name", default: true },
    {
      name: "Documento",
      id: "userDocument",
      oneResult: true
    },
    { name: "Correo", id: "userEmail", oneResult: true }
  ]
};

export const MEDICAL_ORDER_ACCESS = {
  GET: "consultar plantilla de ordenes",
  POST: "subir ordenes"
};

export const ORDER_ASSINGNED = "Orden Asignada-";

export const FIELDS_ORDER_TO_PRELOAD = {
  CUPS: "fh7mnCcXft",
  DATE_CREATED: "fdeAag5S3t",
  PATIENT_IDENTIFICATION_TYPE: "fwJJJqqmwt",
  PATIENT_SEX: "fbl3sqqF3t",
  PATIENT_NAME: "fPgjhv6DFt",
  PATIENT_LASTNAME: "f-We3PcjHt",
  PATIENT_PHONE: "fVIw5wI2ct",
  USER_NAME: "fv65VAu8qt"
};

export const FIELDS_MAPED_FROM_USER = {
  FIRST_NAME: "f5KNE6bVDt",
  SECOND_NAME: "fTZFE1bE2t",
  FIRST_LASTNAME: "fJ9TeCyWpt",
  SECOND_LASTNAME: "fXj4khcdDt",
  IDENTIFICATION_TYPE: "fOQWTidGVt",
  DOCUMENT: "fcvnyPp0vt",
  SEX: "fGnOjAXEpt",
  PHONE: "fevGY5fgRt",
  COUNTRY: "fwDSsLHa4t",
  DEPARTMENT: "f779AWX_Pt",
  CITY: "fHsppPte8t"
};
